<template>
    <div>
        <div class="columns is-multiline" style="border-bottom:#ddd solid 0.8px">
            <div class="column is-full">
                <b-field label="Display en home">
                    <b-switch
                    v-model="section.display">
                    </b-switch>
                </b-field>
            </div>
            <div class="column is-full">
                <b-field label="Titulo">
                    <b-input
                    v-model="section.title"
                    required>
                    </b-input>
                </b-field>
            </div>
            <div class="column is-full">
                <b-field label="Texto">
                    <b-input
                    v-model="section.text"
                    required
                    type="textarea">
                    </b-input>
                </b-field>
            </div>
            <div class="column m-t-30 has-text-centered">
                <b-button
                rounded
                type="is-primary"
                :loading="updateLoad"
                @click="updateSection">
                    <b-icon icon="save" size="is-small"></b-icon>
                    Guardar indo de seccion
                </b-button>
            </div>
        </div>

        <CaseElement
        v-for="(x, i) in cases"
        :key="x.id"
        :data="x"
        :index="i"
        :isNew="false"
        @updated="updateCase"
        @deleteElement="deleteCase"
        />

        <div class="columns m-t-30">
            <div class="column is-full has-text-centered">

                <p v-if="!cases.length" class="title is-size-5">
                    No hay ningun caso de uso, agrega uno asi tus prospectos saben como es trabajar contigo.
                </p>

                <b-button
                type="is-primary"
                rounded
                @click="addModal=true">
                    <b-icon icon="plus" size="is-small"></b-icon>
                    Crear nuevo caso de uso.
                </b-button>
            </div>
        </div>

        <b-modal :active.sync="addModal"  scroll="keep" >
            <div class="modal-card" style="width: auto">
                <div class="modal-card-body">
                    <CaseElement
                    :data="newCase"
                    :index="0"
                    :isNew="true"
                    />
                    <div class="columns m-t-30">
                        <div class="column is-full has-text-centered">
                            <b-button
                            type="is-primary"
                            rounded
                            :loading="createLoad"
                            @click="createCase">
                                <b-icon icon="save" size="is-small"></b-icon>
                               Crear caso de uso.
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>


    </div>
</template>

<script>
import { getHandler, patchHandler, deleteHandler, debounce, postHandler } from '../../../../services/http'
import CaseElement from './CaseElement.vue'

export default {
    components:{
        CaseElement
    },
    props:{
        caseSection:{
            type:String,
            default:""
        },
        caseDetail:{
            type:String,
            default:""
        },
        caseList:{
            type:String,
            default:""
        },
        caseCreate:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            cases:[],
            section:{
                title:'',
                section:''
            },
            newCase:{
                image:'',
                title:'',
                aboutThem:'',
                whatTheySay:''
            },
            loading:false,
            updateLoad:false,
            addModal:false,
            createLoad:false
        }
    },
    methods:{
        async fetchSection(){
            this.loading = true
            let resp = await getHandler(this.caseSection, {error:false, success:false})
            this.section = resp
            this.loading = false
        },
        async updateSection(){
            this.updateLoad = true
            let msg = {
                resource:'notify'
            }
            let resp = await patchHandler(this.caseSection, this.section, {error:msg, success:msg})
            this.updateLoad = false
            this.fetchSection()
        },
        async fetchCases(){
            this.loading = true
            let resp = await getHandler(this.caseList, {error:false, success:false})
            this.cases = resp
            this.loading = false
        },
        async deleteCase(payload){
            let msg = {
                resource:'notify'
            }
            let url = this.caseDetail.replace("0000", payload.id)
            let resp = await deleteHandler(url, {error:msg, success:msg})
            this.fetchCases()
        },
        updateCase: debounce(async function(payload){
            let msg = {
                resource:'notify'
            }
            let url = this.caseDetail.replace("0000", payload.id)
            let resp = await patchHandler(url, this.cases[payload.index], {error:msg, success:msg})
            this.fetchCases()
        },
        600
        ),
        async createCase(){
            let msg = {
                resource:'notify'
            }
            this.createLoad = true
            let resp = await postHandler(this.caseCreate, this.newCase, {error:msg, success:msg})
            this.createLoad = false
            this.newCase={
                image:'',
                title:'',
                aboutThem:'',
                whatTheySay:''
            }
            this.fetchCases()
        }

    },
    created(){
        this.fetchSection()
        this.fetchCases()
    }
}
</script>